export const defaultState = () => {
    return {
        selected: 'en-US',
        source: 'fallback',
        rtl: false,
        filters: [],
        all: []
    }
}

const state = defaultState()
export default state
